export function findParentByAttribute(node, attribute) {
    while ((node = node.parentElement) && !node.getAttribute(attribute));
    return node;
}



// WEBPACK FOOTER //
// ./js/common/utils/domUtils.js